import React, { Component } from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import { connect } from 'react-redux';
import Aux from "../../hoc/_Aux";
import Breadcrumb from "../../App/layout/AdminLayout/Breadcrumb";
import logo from '../../assets/images/auth/logo-big.png';
import trustLog from '../../assets/images/auth/HKJC_Charities_Trust_Logo.png'
import * as actionTypes from "../../store/actions";
import { login, keepCurrentPassword } from '../../api/login';
import storage from '../../store/storage'
import Swal from 'sweetalert2';
import i18next from 'i18next'
import i18n from '../../i18n';
import jwt_decode from 'jwt-decode'
import * as errorMessage from '../../store/message'
class Login extends Component {
    // const history = useHistory();
    constructor(props) {
        super(props);
        this.login = this.login.bind(this);
        this.state = {
            account: storage.get('account') || '',
            password: storage.get('password') || '',
            rememberInfo: true,
            showPwd: false,
        }
    }
    accountChange = e => {
        this.setState({ account: e.target.value });
    }
    passwordChange = e => {
        this.setState({ password: e.target.value });
    }
    remberChange = e => {
        let ischeck = !this.state.rememberInfo;
        this.setState({ rememberInfo: ischeck });
    }
    login = (e) => {
        e.preventDefault();
        //提交
        var jsonData = new Object();
        jsonData.account = this.state.account;
        jsonData.password = this.state.password;
        login(jsonData).then(res => {
            console.log(res);
            if (res.return_code === 0)//登入成功
            {
                // 解析token
                var decoded = jwt_decode(res.token);
                var ExpiredDay = parseInt(decoded.ExpiredDay);
                const ExpiredNoticeDay = parseInt(decoded.ExpiredNoticeDay);
                if (ExpiredDay <= ExpiredNoticeDay) {
                    this.expiredNotice(res);
                } else {
                    this.setLoginInfo(res);
                }
            } else if (res.return_code === 60010)//來自一次性密碼登入
            {
                this.props.history.push({ pathname: "/resetPassword", state: { LoginID: res.loginID, VerifyCode: this.state.password, dataFrom: "member" } });
            }
            else {  //登入失敗
                var items = errorMessage.ErrorMessage.find(p => p.code === res.return_code);
                let message = (i18next.language === "en-US" ? items.enmsg : items.msg).replace("{RemainingTime}", res.remainingTime);
                Swal.fire({
                    icon: 'error',
                    title: i18n.t('LoginPage.Swal.login_fail_msg') + message,
                    confirmButtonText: i18n.t('LoginPage.Swal.btn_ok'),
                    allowOutsideClick: false
                    //timer: 2000,
                })
            }
        }, err => {

        }).catch(err => {
            //alert(err.message);
            console.log('ex:' + err);
        })

    }

    setLoginInfo = (res) => {
        const decoded = jwt_decode(res.token);
        var ExpiredDay = parseInt(decoded.ExpiredDay);
        const ExpiredNoticeDay = parseInt(decoded.ExpiredNoticeDay);
        //ngo info
        var userInfo = new Object();
        userInfo.ngoID = decoded.NGOId;
        userInfo.ngoName = decoded.NGOName;
        userInfo.ngoNameChi = decoded.NGONameChi;
        userInfo.ngoCode = decoded.NGOCode;
        //centre info
        userInfo.centreId = decoded.CentreId;
        userInfo.centreCode = decoded.CentreCode;
        userInfo.centreName = decoded.CentreName;
        userInfo.centreNameChi = decoded.CentreNameChi;
        userInfo.centrePhone = decoded.CentrePhone;
        userInfo.centreContactName = decoded.CentreContactName;
        //member info
        userInfo.memberID = decoded.memberID;
        userInfo.memberUID = decoded.memberUID;
        userInfo.memberNameChi = decoded.memberChineseName;
        userInfo.memberName = decoded.memberEnglishName;
        userInfo.memberGender = decoded.memberGender;
        userInfo.memberMobile = decoded.memberMobile;
        userInfo.memberDOB = decoded.memberDOB;
        userInfo.memberLoginID = decoded.memberLoginID;
        userInfo.noticeDate=new Date().toLocaleDateString();
        storage.set("userInfo", JSON.stringify(userInfo));
        // 修改redux中的token值
        storage.set("token", res.token);
        storage.set("refresh_token", res.refresh_token)
        storage.set('isAuth', true); // Auth for login the system
        if (this.state.rememberInfo) {
            storage.set("account", this.state.account);
            storage.set("password", this.state.password)
        } else {
            storage.remove("account");
            storage.remove("password");
        }
        this.props.authChange(); // Update the global state isAuth by localStorage's value
        this.props.updateNav("dashboard"); // For demo only - make active tab to dashboard in bottom bar
        this.props.history.push("/dashboard"); // Move to the landing page
    }
    expiredNotice = (res) => {
        // 解析token
        var decoded = jwt_decode(res.token);
        var ExpiredDay = parseInt(decoded.ExpiredDay);
        var msg = "";
        if (ExpiredDay === 0) {
            msg = i18n.t('LoginPage.Swal.today_Expired_msg');
        } else if (ExpiredDay > 0) {
            msg = i18n.t('LoginPage.Swal.Hava_Expired_msg', { ExpiredDay: ExpiredDay });
        }
        else {
            msg = i18n.t('LoginPage.Swal.Expired_msg', { ExpiredDay: Math.abs(ExpiredDay) });
        }
        Swal.fire({
            icon: 'question',
            title: msg,
            allowOutsideClick: false,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: i18n.t('LoginPage.Swal.btn_change_msg'),
            denyButtonText: i18n.t('LoginPage.Swal.btn_deny_msg'),
            cancelButtonText: i18n.t('LoginPage.Swal.btn_next_msg'),
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.props.history.push("/changePassword")
            } else if (result.isDenied) {
                this.keepcurPasswordNotice(res);
            } else {
                this.setLoginInfo(res);
            }
        })
    }

    keepcurPasswordNotice = (res) => {
        var decoded = jwt_decode(res.token);
        var LoginID = parseInt(decoded.memberLoginID);
        Swal.fire({
            icon: 'warning',
            title: i18n.t('LoginPage.Swal.confirm_msg'),
            confirmButtonText: `<i class='feather icon-check'/> ${i18n.t('LoginPage.Swal.btn_confirm_ok')}`,
            confirmButtonColor: "#1e4c90",
            showCancelButton: true,
            cancelButtonText: `<i class='feather icon-x'/> ${i18n.t('LoginPage.Swal.btn_confirm_cancel')}`,
            allowOutsideClick: false
        }).then((isConfirm) => {
            if (isConfirm.isConfirmed) {
                keepCurrentPassword(LoginID).then(rs => {
                    if (rs.return_code === 0)//修改成功
                    {
                        this.setLoginInfo(res);
                    } else {
                        var items = errorMessage.ErrorMessage.find(p => p.code == rs.return_code);
                        let message = i18next.language === "en-US" ? items.enmsg : items.msg;
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('SetPasswordPage.Swal.resetPassword_fail_msg') + message,
                            allowOutsideClick: false,
                            confirmButtonText: i18n.t('SetPasswordPage.Swal.btn_ok'),
                            //timer: 1500,
                        })
                    }
                }, err => {

                }).catch(err => {
                    //alert(err.message);
                    console.log('ex:' + err);
                })
            } else {
                this.expiredNotice(res);
            }

        })
    }
    render() {
        const loginForm = (
            <ValidationForm onSubmit={this.login} >
                <Form.Row>
                    <Form.Group as={Col} md="12" >
                        <p htmlFor="account" className="m-0">
                            <b><i className="feather icon-user mr-2" />{i18n.t('LoginPage.lb_username')}</b>
                        </p>
                        <TextInput
                            name="account"
                            id="account"
                            placeholder={i18n.t('LoginPage.ph_username')}
                            required
                            errorMessage={{ required: i18n.t('LoginPage.form_valid.username_required') }}
                            autoComplete="off"
                            value={this.state.account}
                            onChange={this.accountChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                        <p htmlFor="password" className="m-0">
                            <b><i className="feather icon-unlock mr-2" />{i18n.t('LoginPage.lb_password')}</b>
                        </p>
                        <TextInput
                            name="password"
                            id="password"
                            type={this.state.showPwd === false ? "password" : "text"}
                            placeholder={i18n.t('LoginPage.ph_password')}
                            required
                            errorMessage={{ required: i18n.t('LoginPage.form_valid.password_required') }}
                            autoComplete="off"
                            value={this.state.password}
                            onChange={this.passwordChange}
                        />
                        <span className={this.state.showPwd ? "fas fa-eye fa-1x form-control-feedback" : "fas fa-eye-slash fa-1x form-control-feedback"} onClick={() => { this.setState({ showPwd: !this.state.showPwd }) }}></span>
                        {/* <Row>
                            <Col xs={11} md={11}> <TextInput
                                name="password"
                                id="password"
                                type="password"
                                placeholder={i18n.t('LoginPage.ph_password')}
                                required
                                errorMessage={{ required: i18n.t('LoginPage.form_valid.password_required') }}
                                autoComplete="off"
                                value={this.state.password}
                                onChange={this.passwordChange}
                            /></Col>
                            <span className="fas fa-eye fa-1x"></span>
                        </Row> */}


                    </Form.Group>
                    <Form.Group as={Col} md="12">
                        <input type="checkbox" className="mr-2" name="rememberMe" id="rememberMe" checked={this.state.rememberInfo} onChange={this.remberChange} />
                        <label className="form-check-label" htmlFor="rememberMe">{i18n.t('LoginPage.lb_remember_login_info')}</label>
                    </Form.Group>
                </Form.Row>
                <Button variant="primary" className="btn-block mb-2" type="submit">
                    <i className="feather icon-log-in mr-2" />{i18n.t('LoginPage.btn_login')}
                </Button>
                <Button variant="secondary" className="btn-block mb-0" type="button" onClick={() => this.props.history.push("/forgetPassword")}>
                    <i className="feather icon-help-circle mr-2" />{i18n.t('LoginPage.btn_forgetPassword')}
                </Button>
                <Button variant="secondary" className="btn-block mb-0" type="button" onClick={() => this.props.history.push("/startAccount")}>
                    <i className="fa fa-key mr-2" />{i18n.t('LoginPage.btn_startAccount')}
                </Button>
            </ValidationForm>
        );

        const formContainer = (
            <Card>
                <Row className="align-items-center justify-content-center">
                    <Col xs={12} md={6}>
                        <Card.Img variant="top" src={logo} alt="CardImageCap" />
                        <Card.Img src={trustLog}></Card.Img>
                    </Col>
                    <Col xs={12} md={6}>
                        <Card.Body className="px-2 py-3">
                            <Card.Title as="h3">{i18n.t('LoginPage.card_title')}</Card.Title>
                            {loginForm}
                        </Card.Body>
                    </Col>
                </Row>
            </Card>
        );

        return (
            <Aux>
                <Breadcrumb />
                <div className="auth-wrapper auth-bg-img-dim">
                    <div className="auth-content container">
                        {formContainer}
                    </div>
                </div>
            </Aux>
        );
    }

}


const mapStateToProps = state => {
    return {
        isAuth: state.isAuth,
        activeTab: state.activeTab
    }
};

const mapDispatchToProps = dispatch => {
    return {
        authChange: () => dispatch({ type: actionTypes.CHANGE_AUTH }),
        updateNav: (id) => dispatch({ id, type: actionTypes.UPDATE_NAV })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);